import { render, staticRenderFns } from "./ServiceCharge.vue?vue&type=template&id=f4418e44&scoped=true"
import script from "./ServiceCharge.vue?vue&type=script&lang=js"
export * from "./ServiceCharge.vue?vue&type=script&lang=js"
import style0 from "./ServiceCharge.vue?vue&type=style&index=0&id=f4418e44&prod&scoped=true&lang=scss&ref=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4418e44",
  null
  
)

export default component.exports